<script lang="ts" generics="Value extends string">
	let {
		label,
		icon,
		iconLabel,
		value,
		options,
		onChange
	}: {
		label: string;
		icon: string;
		iconLabel: string;
		value: Value;
		options: { value: Value; label: string }[];
		onChange: (value: Value) => void;
	} = $props();
	const id: string = $props.id();
	const selectedLabel: string = $derived(
		options.find((option) => option.value === value)?.label ?? value
	);
</script>

<button
	type="button"
	class="w-full h-8 px-1 flex items-center gap-1.5 rounded text-left bg-primary-50 hover:brightness-90 dark:bg-navy-900 dark:hover:brightness-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px]"
	aria-label="{label}: {selectedLabel}"
	aria-describedby="{id}-mode"
	onclick={() =>
		onChange(
			options[(options.findIndex((option) => option.value === value) + 1) % options.length].value
		)}
>
	<span class="w-6 shrink-0 flex justify-center">
		<i class="fa-solid {icon}" aria-hidden="true" title={iconLabel}></i>
	</span>
	<span>{label}: {selectedLabel}</span>
	<span id="{id}-mode" class="sr-only">{iconLabel}</span>
</button>
